module.exports = __webpack_public_path__ + "static/media/award-4.bbdf7fa8.png";